import cookieUtils from "@/utils/cookieUtils"
import { IS_CHANGE, IS_DETECT_LOADING, IS_SOCKET_DETECT, IS_SOCKET_DETECT_BTN, SIDE_STATUS } from "../../actions/isChange"

let sideStatuss = cookieUtils.get(SIDE_STATUS);

const initState = {
  isChange: false,
}

const initStateDetect = {
  isDetectLoading: true
}

let initStateSide = {
  sideStatus: sideStatuss === 'hide' ? false : true,
}

let initSocket = {
  sessionId: '',
}
let initSocketLeft = {
  isLeft: '',
}

export const isChangeStateReducer = (state = initState, action = {}) => {
  switch (action.type) {
    case IS_CHANGE:
      return { ...state, ...action }
    default:
      return state
  }
}

export const isSideStatusStateReducer = (state = initStateSide, action = {}) => {
  switch (action.type) {
    case SIDE_STATUS:
      cookieUtils.set(SIDE_STATUS, action.sideStatus ? 'show' : 'hide');
      return { ...state, ...action }
    default:
      return state
  }
}

export const isSokectIdReducer = (state = initSocket, action = {}) => {
  switch (action.type) {
    case IS_SOCKET_DETECT:
      return { ...state, ...action }
    default:
      return state
  }
}

export const isSokectIdReducerLeft = (state = initSocketLeft, action = {}) => {
  switch (action.type) {
    case IS_SOCKET_DETECT_BTN:
      return { ...state, ...action }
    default:
      return state
  }
}


export const isDetectLoadingStateReducer = (state = initStateDetect, action = {}) => {
  switch (action.type) {
    case IS_DETECT_LOADING:
      return { ...state, ...action }
    default:
      return state
  }
}